import { ActionButtonProps, Box, ColorOptions, Form, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { EmType } from '../..'
import { RadioButtonWithTitle } from '../../../../components/RadioButtonWithTitle'
import { useLazyApiData, useStores } from '../../../../data/store'
import { isAccessible } from '../../../../utils'
import { settlementDetailsFormData } from './formData'

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const SettlementDetails = ({ type, isLinkToMAS, selectedEntity }: any) => {
  const {
    updateBusinessDetail,
    updateBusinessDetails,
    getSettlementDetails,
    searchedMasMid,
    fetchAllBankDetailsByIFSC,
    getLovsFromKey,
    getLovsDescriptionFromKeyValue,
    accessConfig,
    fetchAllLovs,
  } = useStores((store) => ({
    updateBusinessDetail: store.onboarding.updateBusinessDetail,
    updateBusinessDetails: store.onboarding.updateBusinessDetails,
    getSettlementDetails: store.getEntitySettlementDetails,
    searchedMasMid: store.onboarding.searchedMasMid,
    fetchAllBankDetailsByIFSC: store.fetchAllBankDetailsByIFSC,
    getLovsFromKey: store.getLovsFromKey,
    getLovsDescriptionFromKeyValue: store?.getLovsDescriptionFromKeyValue,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'ems_config']),
    fetchAllLovs: store.fetchAllLovs,
  }))
  const [isEdit, setEditMode] = useState(
    type !== EmType.Search && type !== EmType.createSingleEntity && type !== EmType.applicationQueue,
  )
  const [bankDetails, setBankDetails] = useState({
    bankName: '',
    branchName: '',
    bankCity: '',
    ifsCode: '',
    accountNumber: '',
    beneficiaryName: '',
    settlementFrequency: '',
    settlementStatus: '',
    settlPlanId: '',
    acctType: '',
    dailyTransactionValue: '',
  })

  useEffect(() => {
    if (selectedEntity && selectedEntity?.id) {
      setBankDetails(getSettlementDetails(selectedEntity?.id ?? selectedEntity?.masMid, type))
    } else if (searchedMasMid) {
      setBankDetails(getSettlementDetails(searchedMasMid, type))
    } else if (selectedEntity && selectedEntity?.applicationId) {
      setBankDetails(selectedEntity?.settlementDetails)
    }
  }, [selectedEntity, searchedMasMid, getSettlementDetails, type])

  const [allowSettlement, setAllowSettlement] = useState(false)

  const [fetchAllBankDetailsByIFSCApi, fetchAllBankDetailsByIFSCHandler] = useLazyApiData(fetchAllBankDetailsByIFSC)
  const [getLovs, getSingleLovHandler] = useLazyApiData(fetchAllLovs)

  useEffect(() => {
    getLovs(
      ...[
        'SettlementFrequency',
        'TerminalStatus',
        'SettlementStatus',
        'DailyTransactionValue',
        'SettlementAccountType',
      ],
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (bankDetails?.ifsCode?.length > 0 && bankDetails?.bankName === null && bankDetails?.ifsCode !== 'NA') {
      fetchAllBankDetailsByIFSCApi(bankDetails?.ifsCode)
    }
  }, [bankDetails, bankDetails?.ifsCode, bankDetails?.bankName, fetchAllBankDetailsByIFSCApi])

  useEffect(() => {
    if (fetchAllBankDetailsByIFSCHandler?.state === 'fulfilled') {
      const data = fetchAllBankDetailsByIFSCHandler?.data
      if (
        fetchAllBankDetailsByIFSCHandler?.data &&
        bankDetails.bankName !== data?.bank &&
        bankDetails.branchName !== data?.branch &&
        bankDetails?.bankCity !== data?.city
      ) {
        setBankDetails({
          ...bankDetails,
          bankName: data?.bank,
          branchName: data?.branch,
          bankCity: data?.city,
        })
      }
    }
  }, [
    fetchAllBankDetailsByIFSCHandler,
    fetchAllBankDetailsByIFSCHandler?.state,
    fetchAllBankDetailsByIFSCHandler?.data,
    bankDetails,
  ])

  const onEditPress = () => {
    setEditMode(true)
  }
  const onEditCancelPress = () => {
    setEditMode(false)
  }
  const onSavePress = () => {
    setEditMode(false)
  }

  const updateAllowSettlement = (data: string, selectedChoice: string) => {
    console.log('updateAllowSettlement selectedChoice', data, selectedChoice)
    setAllowSettlement(selectedChoice === 'Yes')
    updateBusinessDetail('allowSettlement', selectedChoice === 'Yes')
  }

  const actionButtons = ({ values, isCurrentFormValid }: ActionButtonProps) => {
    if (isCurrentFormValid) {
      updateBusinessDetails(values, type)
    }
  }
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40}>
      <ModBox show={fetchAllBankDetailsByIFSCHandler?.state === 'pending'}>
        <Loader />
      </ModBox>
      <Box flexDirection={'row'} justifyContent={'space-between'}>
        <Box flexDirection={'row'}>
          <Text title={'Settlement Details'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <Spacer size={18} direction={'vertical'} />
          <ModBox show={true} backgroundColor={'#FBF6EC' as ColorOptions} borderRadius={2} padding={4} marginLeft={16}>
            <Text
              title={'Below information is fetched from MAS.'}
              color={'#A97425' as ColorOptions}
              fontSize={12}
              fontFamily={'jiotype-medium'}
              fontStyle={'italic'}
            />
          </ModBox>
        </Box>
        <ModBox show={false}>
          <ModBox show={isEdit} direction={'row'}>
            <ButtonNew
              type={'secondarySmall'}
              borderWidth={1}
              title={'Cancel'}
              borderColor={'#0070B6'}
              borderRadius={4}
              onPress={onEditCancelPress}
            />
            <Spacer size={16} direction={'horizontal'} />
            <ButtonNew
              height={32}
              borderWidth={1}
              title={'Save Changes'}
              borderColor={'#0070B6'}
              borderRadius={4}
              onPress={onSavePress}
              color={'#0070B6'}
            />
          </ModBox>
          <ModBox show={!isEdit && isAccessible(accessConfig, 'create')}>
            <ButtonNew
              type={'secondaryIconSmall'}
              borderWidth={1}
              title={'Edit'}
              borderColor={'#0070B6'}
              borderRadius={4}
              icon="EDIT"
              onPress={onEditPress}
            />
          </ModBox>
        </ModBox>
      </Box>
      <ModBox marginTop={32}>
        <ModBox show={type !== EmType.createSingleEntity && type !== EmType.Search && type !== EmType.applicationQueue}>
          <RadioButtonWithTitle
            title="Allow Settlement"
            data={['Yes', 'No']}
            textSize={12}
            size={12}
            textPadding={0}
            minItemHeight={36}
            horizontalGap={8}
            direction={'horizontal'}
            onChange={updateAllowSettlement}
          />
        </ModBox>
        <ModBox show={isLinkToMAS === false ? allowSettlement : true}>
          <Form
            formData={settlementDetailsFormData(
              'Once a Day',
              'Active',
              isLinkToMAS,
              isLinkToMAS ? isEdit : true,
              getLovsFromKey,
            )}
            actionButtons={actionButtons}
            initialValues={
              isLinkToMAS
                ? {
                    settlementAccount: !isEmpty(bankDetails?.accountNumber) ? bankDetails?.accountNumber : 'NA',
                    ifsc: !isEmpty(bankDetails?.ifsCode) ? bankDetails?.ifsCode : 'NA',
                    bankName: !isEmpty(bankDetails?.bankName) ? bankDetails?.bankName : 'NA',
                    branch: !isEmpty(bankDetails?.branchName) ? bankDetails?.branchName : 'NA',
                    bankCity: !isEmpty(bankDetails?.bankCity) ? bankDetails?.bankCity : 'NA',
                    beneficiaryName: !isEmpty(bankDetails?.beneficiaryName) ? bankDetails?.beneficiaryName : 'NA',
                    settlementFrequency:
                      bankDetails?.settlementFrequency !== null && bankDetails?.settlementFrequency !== undefined
                        ? getLovsDescriptionFromKeyValue('SettlementFrequency', `${bankDetails?.settlementFrequency}`)
                        : 'NA',
                    settlementPlanID: !isEmpty(bankDetails?.settlPlanId) ? bankDetails?.settlPlanId : 'NA',
                    settlementStatus: !isEmpty(bankDetails?.settlementStatus)
                      ? getLovsDescriptionFromKeyValue('SettlementStatus', bankDetails?.settlementStatus)
                      : 'NA',
                    settlementAccountType: !isEmpty(bankDetails?.acctType)
                      ? getLovsDescriptionFromKeyValue('SettlementAccountType', bankDetails?.acctType)
                      : 'NA',
                    dailyTransactionValue: !isEmpty(bankDetails?.dailyTransactionValue)
                      ? getLovsDescriptionFromKeyValue('DailyTransactionValue', bankDetails?.dailyTransactionValue)
                      : 'NA',
                  }
                : {
                    settlementAccount: '',
                    ifsc: '',
                    bankName: '',
                    branch: '',
                    bankCity: '',
                    beneficiaryName: '',
                    settlementFrequency: '',
                    settlementPlanID: '',
                    settlementStatus: '',
                  }
            }
            container={FormBox}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { SettlementDetails }
